import { render } from "./SpinnerView.vue?vue&type=template&id=5f873ec8"
const script = {}

import exportComponent from "/var/www/ep/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__